export enum TCOLanguages {
  KZ = 'kz',
  RU = 'ru',
  EN = 'en',
}
